export default __webpack_public_path__ + "f0b47e402df6c11a2e9896d166b96f2e.glb";